import { toast as toastify, type ToastOptions } from 'react-toastify'
import { emotionTheme } from '@styles/theme'
import { CheckCircleIcon, WarningIcon, XCircleIcon } from '@phosphor-icons/react'

import * as S from './styles'

const baseConfig: ToastOptions = {
  position: 'top-right',
  autoClose: 3000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  theme: 'colored',
  icon: false,
  closeButton: ({ closeToast }) => <S.CloseButton onClick={closeToast}></S.CloseButton>
}

const getIcon = (type?: 'success' | 'error' | 'warning') => {
  switch (type) {
    case 'success':
      return <CheckCircleIcon size={32} />
    case 'error':
      return <XCircleIcon size={32} />
    case 'warning':
      return <WarningIcon size={32} />
    default:
      return null
  }
}

const renderContent = (message: string, _statusCode?: number, type?: 'success' | 'error' | 'warning') => (
  <S.ToastContent>
    <S.IconWrapper type={type}>{getIcon(type)}</S.IconWrapper>
    <S.TextWrapper>
      <S.ToastMessage type={type}>{message}</S.ToastMessage>
    </S.TextWrapper>
  </S.ToastContent>
)

export const toast = {
  success: (message: string, statusCode?: number, autoClose?: number) =>
    toastify.success(renderContent(message, statusCode, 'success'), {
      ...baseConfig,
      autoClose: autoClose || baseConfig.autoClose,
      style: {
        ...styles,
        background: emotionTheme.colors.green.background
      }
    }),
  warning: (message: string, statusCode?: number, autoClose?: number) =>
    toastify.warn(renderContent(message, statusCode, 'warning'), {
      ...baseConfig,
      autoClose: autoClose || baseConfig.autoClose,
      style: {
        ...styles,
        background: emotionTheme.colors.orange.background
      }
    }),
  error: (message: string, statusCode?: number, autoClose?: number) =>
    toastify.error(renderContent(message, statusCode, 'error'), {
      ...baseConfig,
      autoClose: autoClose || baseConfig.autoClose,
      style: {
        ...styles,
        background: emotionTheme.colors.red.background
      }
    })
}

const styles = {
  color: '#FFF',
  fontSize: '14px',
  lineHeight: '20px',
  minHeight: '48px',
  padding: '12px 24px 12px 14px',
  width: 'auto',
  maxWidth: 'none',
  boxShadow: '0 8px 16px 0 rgba(0, 0, 0, 0.10)'
}
